import { Inject, Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ResponseValidatorService } from '../service/validator/response-validator.service';
import { ErrorHandlerService, NotificationModel, NotificationService, NotificationType } from '@lib/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ResponseInterceptor implements HttpInterceptor {
  constructor(
    private responseValidatorService: ResponseValidatorService,
    protected errorHandlerService: ErrorHandlerService,
    protected notificationService: NotificationService,
    protected translateService: TranslateService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (req.url.indexOf('.json') === -1) {
      return next.handle(req).pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status === 200) {
              return of(new HttpResponse({ status: 200, body: null }));
            } else if (err.status === 500) {
              if (this.errorHandlerService.isExtSoapError(err)) {
                this.notificationService.addNotification(new NotificationModel(this.translateService.instant('errors.ext-soap'), NotificationType.ALERT));
                return of(new HttpResponse({ status: 500, body: [] }));
              }
            }

            this.responseValidatorService.handleHttpError(err);
          } else if (err instanceof Error) {
            this.responseValidatorService.handleOtherErrors(err);
          }

          return throwError(() => err);
        })
      );
    }

    return next.handle(req);
  }
}
